import { useInfiniteQuery } from "react-query";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { VotacaoParticipanteResponse } from "../typings";
import axios from "infra/http";

export function useAssembleiaRelatorioParticipantes(
  id: string,
  params?: PaginateQuery
) {
  return useInfiniteQuery(
    `/v1/relatorios/votacao/${id}/participantes/${params?.search}-${params?.limit}`,
    async ({ pageParam }) => {
      const { data } = await axios.get<
        PaginateResult<VotacaoParticipanteResponse>
      >(`/v1/relatorios/votacao/${id}/participantes`, {
        params: {
          ...params,
          page: pageParam ?? 1,
        },
      });

      return data;
    },
    { getNextPageParam: (lastPage) => lastPage.meta.currentPage === lastPage.meta.totalPages ? undefined : lastPage.meta.currentPage + 1, }
  );
}
